export default __webpack_public_path__ + "static/media/icon_subtract.37978806.svg";